import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { secureBaseQuery } from './secureBaseQuery.js';
import { api } from '../../Appjs/api.js';
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
export const commonApi = createApi({
    reducerPath: 'commonApi',
    //    baseQuery: dynamicBaseQuery,
    baseQuery: fetchBaseQuery({
        baseUrl:api,
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem('accessToken')
            if (token) {
                headers.set("Authorization", `Bearer ${token}`)
            }
            return headers;
        }
    }),
    tagTypes: ["Common"],
    endpoints: (builder) => ({
        getWebDetails: builder.query({
            query: (url) => ({
                url: `/common/get-doamain-details?domain=${url}`,
                method: "GET"
            }),
            providesTags: ["Common"]
        }),
        getdownloadcentercategory: builder.query({
            query: () => `report/get-report-types`,
        }),
        downloadreportrequest: builder.mutation({
            query: (data) => ({
                url: "/report/create-download-report-request",
                method: "POST",
                body: data
            }),
            invalidatesTags: ["Common"]
        }),
    })
})


export const {
    useGetWebDetailsQuery,
    useGetdownloadcentercategoryQuery,
    useDownloadreportrequestMutation,

} = commonApi